























































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {AddressInitState, Amphures, Districts, Provinces} from '@/store/address/address.types';
import {RegisterEnum} from '@/store/auth/auth.enum';
import {Member} from '@/store/member/member.types';

@Component({
  components: {}
})
export default class AddressCurrentComponent extends Vue {

  @State('address') addressInitState!: AddressInitState;
  @Action('_getProvinces', {namespace: 'address'}) getProvinces!: () => Promise<void>;
  @Action('_getAmphures', {namespace: 'address'}) getAmphures!: (payload: string) => Promise<void>;
  @Action('_getDistricts', {namespace: 'address'}) getDistricts!: (payload: string) => Promise<void>;

  public provinces = [{id: 0}] as Provinces[];
  public amphures = [{id: 0}] as Amphures[];
  public districts = [{id: 0}] as Districts[];
  public MemberData = {} as Member;


  async mounted() {

    this.MemberData = await JSON.parse(localStorage.getItem(RegisterEnum.Register) as string) as Member;
    await this.getProvinces();
    this.provinces = this.addressInitState.provinces;
    if (this.MemberData.currentProvinces !== '') {
      await this.getAmphures(this.MemberData.currentProvinces);
      this.amphures = this.addressInitState.amphures;
    }
    if (this.MemberData.currentAmphures !== '') {
      await this.getDistricts(this.MemberData.currentAmphures);
      this.districts = this.addressInitState.districts;
    }
  }

  ChangeData() {
    this.$emit('currentChanged', {
      currentAddress : this.MemberData.currentAddress,
      currentProvinces : this.MemberData.currentProvinces,
      currentAmphures : this.MemberData.currentAmphures,
      currentDistricts : this.MemberData.currentDistricts,
      currentZip : this.MemberData.currentZip
    })
  }

  async selProvinces() {
    await this.getAmphures(this.MemberData.currentProvinces);
    this.amphures = this.addressInitState.amphures;
    await this.ChangeData();
  }

  async selAmphures() {
    await this.getDistricts(this.MemberData.currentAmphures);
    this.districts = this.addressInitState.districts;
    await this.ChangeData();
  }

  async selDistricts() {
    let district = this.districts.find((x) => x.id === Number(this.MemberData.currentDistricts));
    if (district) {
      this.MemberData.currentZip = district.zipCode;
    }
    await this.ChangeData();
  }

}
